var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          title: _vm.$t("pages.locker.my_coach.consulting.title"),
          "use-title-as-document-title": false
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-3" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "card shadow-sm" }, [
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c("p", [
                  _vm._v(
                    _vm._s(_vm.$t("pages.locker.my_coach.consulting.text"))
                  )
                ]),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { to: { name: "locker.my-coach.contact" } }
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t("pages.locker.my_coach.consulting.contact")
                        ) +
                        "\n                    "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("page-header", {
        attrs: {
          title: _vm.$t("pages.locker.my_coach.videos"),
          "use-title-as-document-title": false
        }
      }),
      _vm._v(" "),
      !_vm.$store.getters.shouldLoadLocal
        ? _c("div", [
            _c(
              "div",
              { staticClass: "row" },
              _vm._l(_vm.seriesList, function(series) {
                return _c(
                  "div",
                  { staticClass: "col-md-4 grid-margin" },
                  [_c("series-card", { attrs: { series: series } })],
                  1
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.seriesList.length === 0
              ? _c(
                  "div",
                  {
                    staticClass: "alert alert-secondary border-dark shadow-sm"
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("pages.locker.my_coach.videos_empty")) +
                        "\n        "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-3" },
              [
                _c("pagination", {
                  attrs: { data: _vm.paginationData },
                  on: { "pagination-change-page": _vm.getCoachSeries }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }